import { ChangeEvent, FC, InputHTMLAttributes } from 'react';
import cn from '../../utils/classnames';
import './radio-button.scss';

type RadioButtonProps = InputHTMLAttributes<HTMLInputElement> & {
    id: string;
    checked?: boolean;
    label?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void | (() => void);
};

const RadioButton: FC<RadioButtonProps> = ({ label, id, checked, onChange, disabled, ...props }) => {
    return (
        <span className={cn('radio-button', { disabled, checked })}>
            <input
                type='radio'
                id={`radio-button-${id}`}
                name='radio-group'
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                readOnly={!onChange}
                {...props}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            {label && <label htmlFor={`radio-button-${id}`}>{label}</label>}
        </span>
    );
};

export default RadioButton;
